<template>
  <div style="overflow: scroll;background-color:#fff;">
    <div class="middle">
      <div :style="cardbg" class="card">
        <div>
          <img
            :src="require('@assets/ic_user_portrait.png')"
            class="icon-sex"
            alt=""
          />
          <div class="name">{{ userInfo.patientName }}</div>
          <div>
            <span
              style="margin-top:3px;margin-left:73px;color:rgba(255,255,255,0.65);font-size:17px"
              >{{ userInfo.cardNo }}</span
            >
          </div>
        </div>
      </div>
      <div class="timer" style="margin-top:10px;">
        <ph-empty v-if="!list.length" bgcolor="white" />
        <div v-for="(item, index) in list" :key="index">
          <van-cell
            :title="item.officeName || item.windowNo"
            :value="
              `${item.flag === '1' ? '当前候诊人数' : '当前取药人数'}:${
                item.waitNumber
              }人`
            "
            size="large"
          />
        </div>
      </div>
      <div style="padding-top:1rem;padding-left:1rem;background-color:#fff;">
        <div style="font-weight: bold;font-size: 15px;">温馨提示</div>
        <div style="color:gray;font-size: 15px">
          请及时留意排队候诊信息，按时就诊，过号系统将为您重新排队！
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  components: {},
  data() {
    return {
      list: [],
      intervalTimer: 0,
      userInfo: {}
    };
  },
  created() {
    this.getWaitingList();
    this.intervalTimer = this.timer();
    this.getUserBaseInfo("1").then(res => {
      this.userInfo = res;
    });
  },
  destroyed() {
    clearInterval(this.intervalTimer);
  },
  methods: {
    ...mapActions("users", ["getUserBaseInfo"]),
    getWaitingList() {
      this.$http
        .post(this.$api.WAITING_LIST, { functionType: "1" })
        .then(res => {
          this.list = res;
        });
    },
    timer() {
      return setInterval(() => {
        this.getWaitingList();
      }, 30000);
    }
  }
};
</script>

<style lang="less" scoped>
.name {
  margin-left: 73px;
  padding-top: 18px;
  color: #fff;
  font-weight: bold;
  font-size: 17px;
}

.middle {
  height: 75px;
  margin: 16px 15px 0 15px;
  background-color: #108eee;
  border-radius: 5px;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.07);
}
.icon-sex {
  position: absolute;
  width: 40px;
  height: 40px;
  margin-top: 18px;
  margin-left: 15px;
  background-color: #fff;
  border-radius: 20px;
}
</style>
